export default "__VITE_ASSET__Dqah5Slk__";